import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';

// Components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import newlogo from '../../assets/img/new-logo.png';

class ForgotPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isMailSent: false,
        };
    }

    componentWillUnmount() {
        const { authStore } = this.props;
        authStore.reset();
    }

    handleEmailChange = (e) => {
        this.setState({ email: e.target.value });
    };

    handleSubmitForm = async (e) => {
        e.preventDefault();
        const { authStore } = this.props;

        try {
            await authStore.forgotPasswordLink(this.state.email);
            this.setState({ isMailSent: true });
        } catch (error) {
            console.error('Error sending password reset link:', error);
        }
    };

    render() {
        const { t } = this.props;
        const { isMailSent, email } = this.state;

        return (
            <div>
                <div className="auth-page-wrapper">
                    <ToastContainer />
                    <div className="auth-page-card">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h2 className="fs22 loginTitle">{t('Forgot password').toUpperCase()}</h2>
                            <img src={newlogo} alt="Logo" style={{ height: 42, cursor: 'pointer' }} onClick={() => this.props.router.navigate('/')} />
                        </div>
                        {!isMailSent ? (
                            <>
                                <p className="forogottext mb-3">
                                    {t('Enter your email and we will send you a link to reset your password.')}
                                </p>
                                <form className="login-container" onSubmit={this.handleSubmitForm}>
                                    <div className="row mt-12">
                                        <div className="col-md-12 col-lg-12 col-sm-12">
                                            <div className="form-group business-name">
                                                <label htmlFor="forgotEmail" className="fw-bold">
                                                    {t('Email')}
                                                </label>
                                                <label className="red-star">*</label>
                                                <input
                                                    id="forgotEmail"
                                                    type="email"
                                                    value={email}
                                                    className="form-control login-input mb_25 mt-12"
                                                    placeholder={t('Email address')}
                                                    required
                                                    onChange={this.handleEmailChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn btn-block fwBold fs18 loginbutton" type="submit">
                                        {t('Send Reset Link')}
                                    </button>
                                </form>
                            </>
                        ) : (
                            <p className="forogottext mb-3">
                                {t('Email has been sent. Please check your email inbox')}.
                            </p>
                        )}
                        <div className="d-flex w-100 justify-content-between mt-3 mb-3">
                            <Link className="fs18 loginFooter border-none text-decoration-none" to="/login">
                                {t('Back to login')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('authStore')(applicationRouter(withLocalization(observer(ForgotPasswordPage))));
